export default {
  "content": "<path fill=\"#fff\" fill-rule=\"evenodd\" d=\"M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24z\" clip-rule=\"evenodd\"/><path fill=\"#00809D\" fill-rule=\"evenodd\" d=\"M14.4 23.8c-.772 0-1.4.628-1.4 1.4v8.4c0 .772.628 1.4 1.4 1.4H17V23.8h-2.6zM19 35h12.564c.697 0 1.279-.5 1.383-1.19l1.657-10.801a1.396 1.396 0 00-1.382-1.608H26.4a1 1 0 01-1-1V15.6a2.605 2.605 0 00-1.983-2.526L19 23.012V35zm12.564 2H14.4a3.404 3.404 0 01-3.4-3.4v-8.4c0-1.875 1.525-3.4 3.4-3.4h2.95l4.536-10.206A1 1 0 0122.8 11c2.537 0 4.6 2.064 4.6 4.6v3.801h5.792c1.013 0 1.947.425 2.593 1.167.656.754.946 1.753.796 2.742l-1.657 10.802A3.378 3.378 0 0131.564 37z\" clip-rule=\"evenodd\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "48",
    "height": "48",
    "fill": "none",
    "viewBox": "0 0 48 48"
  }
};